<template>
    <div>
     <b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" @close="this.emitEventCancel" @ok="handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
      
         <Loading v-bind:IsLoading="this.Load" /> 
        <form ref="form_EditNote" @submit.stop.prevent="handleSubmit">
        <MdTitle v-bind:Text="'Condition Code'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
        <b-row>
          <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '1'})"
                    v-bind:ModelCode="condition1"
                    v-bind:ModelDescription="dCondition1"
                    v-bind:RefCode="'Condition1'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false"    
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '1'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition1'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '2'})"
                    v-bind:ModelCode="condition2"
                    v-bind:ModelDescription="dCondition2"
                    v-bind:RefCode="'Condition2'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false"    
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '2'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition2'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '3'})"
                    v-bind:ModelCode="condition3"
                    v-bind:ModelDescription="dCondition3"
                    v-bind:RefCode="'Condition3'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false"    
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '3'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition3'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>  
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '4'})"
                    v-bind:ModelCode="condition4"
                    v-bind:ModelDescription="dCondition4"
                    v-bind:RefCode="'Condition4'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false"    
                    v-bind:Fields="[]"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '4'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition4'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>  
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '5'})"
                    v-bind:ModelCode="condition5"
                    v-bind:ModelDescription="dCondition5"
                    v-bind:RefCode="'Condition5'"
                    v-bind:Api="'conditions'"
                    v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false"    
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '5'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition5'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '6'})"
                    v-bind:ModelCode="condition6"
                    v-bind:ModelDescription="dCondition6"
                    v-bind:RefCode="'Condition6'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false" 
                    v-bind:Fields="[]"   
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '6'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition6'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '7'})"
                    v-bind:ModelCode="condition7"
                    v-bind:ModelDescription="dCondition7"
                    v-bind:RefCode="'Condition7'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"                    
                    :IsDisabled="false" 
                    v-bind:Fields="[]"   
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '7'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition7'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>              
        </b-row>
         <MdTitle v-bind:Text="'Occurrence Code'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

         <b-row>
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 1'"
                    v-bind:ModelCode="occurrence1"
                    v-bind:ModelDescription="dOccurrence1"
                    v-bind:RefCode="'Occurrence1'"
                    v-bind:Api="'Occurrences'"
                    v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 1'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence1'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 1'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate1'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate1" 
                    @input="ChangeDate1"
                    v-bind:Tag="'ClaimOccDate1'"/>
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 2'"
                    v-bind:ModelCode="occurrence2"
                    v-bind:ModelDescription="dOccurrence2"
                    v-bind:RefCode="'Occurrence2'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 2'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence2'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 2'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate2'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate2" 
                    @input="ChangeDate2"
                    v-bind:Tag="'ClaimOccDate2'"/>
            </b-col> 
         </b-row>

          <b-row>
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 3'"
                    v-bind:ModelCode="occurrence3"
                    v-bind:ModelDescription="dOccurrence3"
                    v-bind:RefCode="'Occurrence3'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 3'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence3'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 3'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate3'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate3" 
                    @input="ChangeDate3"
                    v-bind:Tag="'ClaimOccDate3'"/>
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 4'"
                    v-bind:ModelCode="occurrence4"
                    v-bind:ModelDescription="dOccurrence4"
                    v-bind:RefCode="'Occurrence4'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 4'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence4'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 4'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate4'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate4" 
                    @input="ChangeDate4"
                    v-bind:Tag="'ClaimOccDate4'"/>
            </b-col> 
         </b-row>















            <b-row>
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 5'"
                    v-bind:ModelCode="occurrence5"
                    v-bind:ModelDescription="dOccurrence5"
                    v-bind:RefCode="'Occurrence5'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 5'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence5'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 5'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate5'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate5" 
                    @input="ChangeDate5"
                    v-bind:Tag="'ClaimOccDate5'"/>
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 6'"
                    v-bind:ModelCode="occurrence6"
                    v-bind:ModelDescription="dOccurrence6"
                    v-bind:RefCode="'Occurrence6'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 6'" 
                     v-bind:Fields="[]"                 
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence6'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 6'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate6'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate6" 
                    @input="ChangeDate6"
                    v-bind:Tag="'ClaimOccDate6'"/>
            </b-col> 
         </b-row>

          <b-row>
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 7'"
                    v-bind:ModelCode="occurrence7"
                    v-bind:ModelDescription="dOccurrence7"
                    v-bind:RefCode="'Occurrence7'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 7'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence7'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 7'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate7'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate7" 
                    @input="ChangeDate7"
                    v-bind:Tag="'ClaimOccDate7'"/>
            </b-col> 
             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 8'"
                    v-bind:ModelCode="occurrence8"
                    v-bind:ModelDescription="dOccurrence8"
                    v-bind:RefCode="'Occurrence8'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 8'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence8'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 8'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate8'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate8" 
                    @input="ChangeDate8"
                    v-bind:Tag="'ClaimOccDate8'"/>
            </b-col> 
         </b-row>

           <b-row>
            <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 9'"
                    v-bind:ModelCode="occurrence3"
                    v-bind:ModelDescription="dOccurrence3"
                    v-bind:RefCode="'Occurrence9'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 9'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence9'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"                     
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Date 9'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDate9'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDate9" 
                    @input="ChangeDate9"
                    v-bind:Tag="'ClaimOccDate9'"/>
            </b-col>            
           </b-row>
 <MdTitle v-bind:Text="'Occurrence Span'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 1'"
                    v-bind:ModelCode="occurrencespan1"
                    v-bind:ModelDescription="dOccurrencespan1"
                    v-bind:RefCode="'Occurrencespan1'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 1'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan1'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFrom1'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan1" 
                    @input="ChangeDateFromSpan1"
                    v-bind:Tag="'ClaimOccDateFrom1'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateTo1'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan1" 
                    @input="ChangeDateToSpan1"
                    v-bind:Tag="'ClaimOccDateToSpan1'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 2'"
                    v-bind:ModelCode="occurrencespan2"
                    v-bind:ModelDescription="dOccurrencespan2"
                    v-bind:RefCode="'Occurrencespan2'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 2'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan2'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDatespan2'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan2" 
                    @input="ChangeDateFromSpan2"
                    v-bind:Tag="'ClaimOccDateFromSpan2'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan2'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan2" 
                    @input="ChangeDateToSpan2"
                    v-bind:Tag="'ClaimOccDateToSpan2'"/>
            </b-col>             
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 3'"
                    v-bind:ModelCode="occurrencespan3"
                    v-bind:ModelDescription="dOccurrencespan3"
                    v-bind:RefCode="'Occurrencespan3'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 3'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan3'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateSpan3'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan3" 
                    @input="ChangeDateFromSpan3"
                    v-bind:Tag="'ClaimOccDateFromSpan3'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan3'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan3" 
                    @input="ChangeDateToSpan3"
                    v-bind:Tag="'ClaimOccDateToSpan3'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 4'"
                    v-bind:ModelCode="occurrencespan4"
                    v-bind:ModelDescription="dOccurrencespan4"
                    v-bind:RefCode="'Occurrencespan4'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 4'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan4'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan4'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan4" 
                    @input="ChangeDateFromSpan4"
                    v-bind:Tag="'ClaimOccDateFromSpan4'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan4'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan4" 
                    @input="ChangeDateToSpan4"
                    v-bind:Tag="'ClaimOccDateToSpan4'"/>
            </b-col>             
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 5'"
                    v-bind:ModelCode="occurrencespan5"
                    v-bind:ModelDescription="dOccurrencespan5"
                    v-bind:RefCode="'Occurrencespan5'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 5'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan5'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan5'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan5" 
                    @input="ChangeDateFromSpan5"
                    v-bind:Tag="'ClaimOccDateFromSpan5'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan5'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan5" 
                    @input="ChangeDateToSpan5"
                    v-bind:Tag="'ClaimOccDateToSpan5'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 6'"
                    v-bind:ModelCode="occurrencespan6"
                    v-bind:ModelDescription="dOccurrencespan6"
                    v-bind:RefCode="'Occurrencespan6'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 6'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan6'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSPan6'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan6" 
                    @input="ChangeDateFromSpan6"
                    v-bind:Tag="'ClaimOccDateFromSpan6'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan6'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan6" 
                    @input="ChangeDateToSpan6"
                    v-bind:Tag="'ClaimOccDateToSpan6'"/>
            </b-col>             
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 7'"
                    v-bind:ModelCode="occurrencespan7"
                    v-bind:ModelDescription="dOccurrencespan7"
                    v-bind:RefCode="'Occurrencespan7'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 7'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan7'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan7'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan7" 
                    @input="ChangeDateFromSpan7"
                    v-bind:Tag="'ClaimOccDateFromSpan7'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan7'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan7" 
                    @input="ChangeDateToSpan7"
                    v-bind:Tag="'ClaimOccDateToSpan7'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 8'"
                    v-bind:ModelCode="occurrencespan8"
                    v-bind:ModelDescription="dOccurrencespan8"
                    v-bind:RefCode="'Occurrencespan8'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 8'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan8'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan8'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan8" 
                    @input="ChangeDateFromSpan8"
                    v-bind:Tag="'ClaimOccDateFromSpan8'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan8'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan8" 
                    @input="ChangeDateToSpan8"
                    v-bind:Tag="'ClaimOccDateToSpan8'"/>
            </b-col>             
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 9'"
                    v-bind:ModelCode="occurrencespan9"
                    v-bind:ModelDescription="dOccurrencespan9"
                    v-bind:RefCode="'Occurrencespan9'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 9'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan9'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan9'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan9" 
                    @input="ChangeDateFromSpan9"
                    v-bind:Tag="'ClaimOccDateFromSpan9'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan9'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan9" 
                    @input="ChangeDateToSpan9"
                    v-bind:Tag="'ClaimOccDateToSpan9'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 10'"
                    v-bind:ModelCode="occurrencespan10"
                    v-bind:ModelDescription="dOccurrencespan10"
                    v-bind:RefCode="'Occurrencespan10'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 10'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan10'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan10'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan10" 
                    @input="ChangeDateFromSpan10"
                    v-bind:Tag="'ClaimOccDateFromSpan10'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan10'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan10" 
                    @input="ChangeDateToSpan10"
                    v-bind:Tag="'ClaimOccDateToSpan10'"/>
            </b-col>             
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 11'"
                    v-bind:ModelCode="occurrencespan11"
                    v-bind:ModelDescription="dOccurrencespan11"
                    v-bind:RefCode="'Occurrencespan11'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 11'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan11'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan11'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan11" 
                    @input="ChangeDateFromSpan11"
                    v-bind:Tag="'ClaimOccDateFromSpan11'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan11'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan11" 
                    @input="ChangeDateToSpan11"
                    v-bind:Tag="'ClaimOccDateToSpan11'"/>
            </b-col>             
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">            
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 12'"
                    v-bind:ModelCode="occurrencespan12"
                    v-bind:ModelDescription="dOccurrencespan12"
                    v-bind:RefCode="'Occurrencespan12'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'" 
                    :SearchTitle="'Occurrence 12'"                  
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan12'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date From'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateFromSpan12'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateFromSpan12" 
                    @input="ChangeDateFromSpan12"
                    v-bind:Tag="'ClaimOccDateFromSpan12'"/>
            </b-col> 
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="'Date To'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'OccuDateToSpan12'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isReadOnly="false"
                    v-model="OccDateToSpan12" 
                    @input="ChangeDateToSpan12"
                    v-bind:Tag="'ClaimOccDateToSpan12'"/>
            </b-col>             
        </b-row>

        <MdTitle v-bind:Text="'Authorization'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <b-row>
            <b-col lg="4" md="4" sm="12">   
                <MdEdit 
                    v-bind:Label="'Authorization 1'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Authorization1'"                   
                    v-model="Authorization1"                  
                    v-bind:Id="'input_ClaimAuthorization1'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">   
                <MdEdit 
                    v-bind:Label="'Authorization 2/ Resub Corrected Claim'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Authorization2'"                   
                    v-model="Authorization2"                 
                    v-bind:Id="'input_ClaimAuthorization2'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">   
                <MdEdit 
                    v-bind:Label="'Authorization 3/ Resub Voided Claim'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Authorization3'"                   
                    v-model="Authorization3"                  
                    v-bind:Id="'input_ClaimAuthorization3'"/>
            </b-col>
        </b-row>

      </form>
     </b-modal>  
     
    </div>
</template>
 
 <script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Loading from '@/components/template/loading/Loading'
//import ISetup from '@/services/isetup.service'
//import { EventBus } from '@/event-bus.js';
 

 export default {
    name: 'ModalClaimOOccAuthoCondition',   
    components: { Loading },
    mixins: [ShowMessage, DBFunctions], 
    props: {
        ModalId: String,
        TitleWindow: String       
    },
   
   data(){
     return {
        Load: false,
        Authorization1:"",
        Authorization2:"",
        Authorization3:"",

        condition1:"", 
        dCondition1:"",  
        condition2:"", 
        dCondition2:"",  
        condition3:"", 
        dCondition3:"",  
        condition4:"", 
        dCondition4:"", 
        condition5:"", 
        dCondition5:"",  
        condition6:"", 
        dCondition6:"",  
        condition7:"", 
        dCondition7:"",
        
        occurrence1:"",
        dOccurrence1:"",
        OccDate1:null,
        occurrence2:"",
        dOccurrence2:"",
        OccDate2:null,
        occurrence3:"",
        dOccurrence3:"",
        OccDate3:null,
        occurrence4:"",
        dOccurrence4:"",
        OccDate4:null,
        occurrence5:"",
        dOccurrence5:"",
        OccDate5:null,
        occurrence6:"",
        dOccurrence6:"",
        OccDate6:null,
        occurrence7:"",
        dOccurrence7:"",
        OccDate7:null,
        occurrence8:"",
        dOccurrence8:"",
        OccDate8:null,
        occurrence9:"",
        dOccurrence9:"",
        OccDate9:null,      

        occurrencespan1:"",
        dOccurrencespan1:"",
        OccDateFromSpan1:null,
        OccDateToSpan1:null,

        occurrencespan2:"",
        dOccurrencespan2:"",
        OccDateFromSpan2:null,
        OccDateToSpan2:null,
        occurrencespan3:"",
        dOccurrencespan3:"",
        OccDateFromSpan3:null,
        OccDateToSpan3:null,
        occurrencespan4:"",
        dOccurrencespan4:"",
        OccDateFromSpan4:null,
        OccDateToSpan4:null,
        occurrencespan5:"",
        dOccurrencespan5:"",
        OccDateFromSpan5:null,
        OccDateToSpan5:null,
        occurrencespan6:"",
        dOccurrencespan6:"",
        OccDateFromSpan6:null,
        OccDateToSpan6:null,
        occurrencespan7:"",
        dOccurrencespan7:"",
        OccDateFromSpan7:null,
        OccDateToSpan7:null,
        occurrencespan8:"",
        dOccurrencespan8:"",
        OccDateFromSpan8:null,
        OccDateToSpan8:null,
        occurrencespan9:"",
        dOccurrencespan9:"",
        OccDateFromSpan9:null,
        OccDateToSpan9:null,
        occurrencespan10:"",
        dOccurrencespan10:"",
        OccDateFromSpan10:null,
        OccDateToSpan10:null,
        occurrencespan11:"",
        dOccurrencespan11:"",
        OccDateFromSpan11:null,
        OccDateToSpan11:null,
        occurrencespan12:"",
        dOccurrencespan12:"",
        OccDateFromSpan12:null,
        OccDateToSpan12:null



     }
   },
 
   methods:{

    ChangeDateFromSpan1(){
    },

    ChangeDateToSpan1(){
    },
    ChangeDateFromSpan2(){
    },

    ChangeDateToSpan2(){
    },
    ChangeDateFromSpan3(){
    },

    ChangeDateToSpan3(){
    },
    ChangeDateFromSpan4(){
    },

    ChangeDateToSpan4(){
    },
    ChangeDateFromSpan5(){
    },

    ChangeDateToSpan5(){
    },
    ChangeDateFromSpan6(){
    },

    ChangeDateToSpan6(){
    },
    ChangeDateFromSpan7(){
    },

    ChangeDateToSpan7(){
    },
    ChangeDateFromSpan8(){
    },

    ChangeDateToSpan8(){
    },
    ChangeDateFromSpan9(){
    },

    ChangeDateToSpan9(){
    },
    ChangeDateFromSpan10(){
    },

    ChangeDateToSpan10(){
    },
    ChangeDateFromSpan11(){
    },

    ChangeDateToSpan11(){
    },
    ChangeDateFromSpan12(){
    },

    ChangeDateToSpan12(){
    },






    ChangeDate1(){

    },

    ChangeDate2(){

    },

    ChangeDate3(){

    },
    ChangeDate4(){

    },
    ChangeDate5(){

    },
    ChangeDate6(){

    },
    ChangeDate7(){

    },
    ChangeDate8(){

    },
    ChangeDate9(){

    },

    handleOk($event){   
        $event.preventDefault();  
        this.$emit('OnResetModal',true);
    },
 

    onCodeConditionOkModal(result){
      var type = result.FieldName;        
             switch (type) {
                case "cpt": 
                  this.Billing = result.code; 
              //    this.parameter.BillingCode = result.code;                   
                  this.bDescription = result.description; 
                //  this.getNotesList();
                  break;
             }
    },

    

    emitEventCancel(){       
        this.$emit('OnResetModal',true);
    },

  
     
   },

    
  mounted(){
   
   },
 };
 </script>

